import React, { useRef, useState } from 'react';
import './App.scss';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Login from './Components/Login/login';
import { useEffect } from 'react';
import RouteItems from './Routes/routes';
import CandidateHeader from './Layout/candidateHeader';
import Signup from './Components/Signup/signup';
import CouponRedeem from './Components/Signup/couponRedeem';
import Modal from 'react-bootstrap/Modal';
import { resentEmail } from './Redux/ActionCreators/authAction';
import { useDispatch } from 'react-redux';
import Candidatetest from './utils/candidatetestLoader';
import AppLayout from './Layout/NewLayout/NewappLayout';
import NotFound from './Components/notFound';
import Home from './Components/home';
import { useTranslation } from 'react-i18next';
import { getTanentDomain } from './Redux/ActionCreators/layoutAction';
import ScheduleStage from './Components/ScheduleStage/scheduleStage';
import QualifyQuestions from './Components/Qualify-Questions/qualifyQuestions';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

function App() {


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getTanentDomain(window.location.host));
  }, [])

  const [scriptLoaded, setScriptLoaded] = React.useState(false);
  // const [showBanner, setShowBanner] = useState(false);

  // Check if the banner should be displayed
  // useEffect(() => {
  //   const bannerClosed = sessionStorage.getItem('bannerClosed');
  //   if (!bannerClosed) {
  //     sessionStorage.setItem('bannerClosed', false);
  //     setShowBanner(false);
  //   }
  // }, []);

  // Close the banner
  // const handleCloseBanner = () => {
  //   sessionStorage.setItem('bannerClosed', true);
  //   setShowBanner(true);
  // };

  // language translation script
  useEffect(() => {
    const isCandidateTest = window.location.pathname.split('/')[1] === 'candidate-test';
    const isQuestionType7or12 =
      window.location.href.includes('questionTypeID=7') ||
      window.location.href.includes('questionTypeID=12');

    // Helper to remove any Google Translate UI
    const removeGoogleTranslateUI = () => {
      // Remove translate banner iframe
      document.querySelectorAll('iframe.goog-te-banner-frame').forEach((el) => el.remove());
      // Remove skiptranslate container
      document.querySelectorAll('.skiptranslate').forEach((el) => el.remove());
      // Reset body style that Google modifies
      document.body.style.top = '0px';
      document.documentElement.style.position = 'static';
    };

    if (isCandidateTest && !isQuestionType7or12) {
      const googleTranslateElementInit = () => {
        try {
          new window.google.translate.TranslateElement(
            {
              autoDisplay: false,
              includedLanguages: 'en,es,pt,it,de,fr,hi',
            },
            'google_translate_element'
          );

          // Keep cleaning up injected banners for a few seconds
          const intervalId = setInterval(removeGoogleTranslateUI, 500);
          setTimeout(() => clearInterval(intervalId), 8000);
        } catch (error) {
          console.error('Error during Google Translate initialization:', error);
        }
      };

      window.googleTranslateElementInit = googleTranslateElementInit;

      const addGoogleTranslateScript = () => {
        if (!document.querySelector('script[src*="translate.google.com"]')) {
          const script = document.createElement('script');
          script.src =
            '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
          script.async = true;
          script.onload = () => setScriptLoaded(true);
          script.onerror = () =>
            console.error('Google Translate script failed to load.');
          document.body.appendChild(script);
        } else {
          setScriptLoaded(true);
        }
      };

      if (!scriptLoaded) {
        addGoogleTranslateScript();
      } else if (window.google?.translate?.TranslateElement) {
        googleTranslateElementInit();
      }
    } else {
      // For questionTypeID 7 or 12 → remove *everything* Translate-related immediately
      removeGoogleTranslateUI();

      // Also remove any Google Translate script tags
      document
        .querySelectorAll('script[src*="translate.google.com"]')
        .forEach((el) => el.remove());
    }
  }, [scriptLoaded]);



  useEffect(() => {

    if (localStorage.getItem('token')) {
      if (localStorage.getItem("profileDetails")) {
        const details = JSON.parse(localStorage.getItem("profileDetails"));
        if (details?.roleId === "1") {
          window.location.pathname === '/' && (
            navigate('/jobs')
          )
        }
        else {
          window.location.pathname === '/' && (
            navigate('/jobs')
          )
        }
      }
      else {
        window.location.pathname === '/' && (
          navigate('/jobs')
        )
      }


    } else {
      (window.location.pathname === '/') && (
        navigate('/login')
      )
    }
  }, [])
  const resendEmail = async () => {
    let obj = {
      id: localStorage.getItem('userId'),
      emailVerificationUrl: window.location.protocol + '//' + window.location.host + "/login/id"
    }
    await dispatch(resentEmail(obj))
  }

  const goToLogin = () => {
    localStorage.clear();
    navigate('/login');
  }
  if (process.env.NODE_ENV === 'production') {
    console.log = function no_console() { };
  }

  return (
    <div>
      {/* <Header /> */}
      <Routes>
        <Route path='/signup' element={<Signup />} />
        <Route path='/couponredeem' element={<CouponRedeem />} />
        <Route path='/login' element={<Login />} />
        <Route path='/login/:code' element={<Home />} />
        <Route path='/candidatetest/:token' element={<Candidatetest />} />
        <Route path='/hiring-stage/:id' element={<ScheduleStage />} />
        <Route path='/pre-screen/:preScreenId' element={<QualifyQuestions />} />

        <Route element={<AppLayout />}>
          {(RouteItems || []).map((item) => {
            if (item.layout === "mainLayout") {
              return (
                <Route key={item.path} path={item.path} element={item.component}>
                  {item.children &&
                    item.children.map((child) => (
                      <Route
                        key={child.path}
                        path={child.path}
                        element={child.component}
                      />
                    ))}
                </Route>
              );
            }

          })
          }
        </Route>
        <Route element={<CandidateHeader />}>
          {(RouteItems || []).map((item) => {
            if (item.layout === "candidate-layout") {
              return (
                <Route
                  key={item.path}
                  path={item.path}
                  element={item.component}
                />
              );
            }

          })
          }
        </Route>
        <Route>
          {(RouteItems || []).map((item) => {
            if (item.layout === "videoInterview-layout") {
              return (
                <Route
                  key={item.path}
                  path={item.path}
                  element={item.component}
                />
              );
            }
          })
          }
        </Route>
        <Route>
          {(RouteItems || []).map((item) => {
            if (item.layout === "candidate-upload") {
              return (
                <Route
                  key={item.path}
                  path={item.path}
                  element={item.component}
                />
              );
            }
          })
          }
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
      {/* <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnFocusLoss draggable pauseOnHover limit={3} newestOnTop={true} /> */}

      {/* Banner message */}
      {/* {
        sessionStorage.getItem('bannerClosed') === 'false' ? (
          <div className='banner-message' style={{ backgroundColor: '#009199', color: '#fff', position: 'fixed', zIndex: '1000', bottom: window.innerWidth > 767 ? "20px" : "0", left: '0', right: '0', borderRadius: '15px', padding: '7px 15px', border: '1px solid #D1D5DB', width: window.innerWidth > 767 ? "840px" : "auto", display: 'flex', justifyContent: 'center', margin: 'auto' }}>
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', marginBottom: '10px' }}>
                <span style={{ fontFamily: 'Poppins, sans-serif', fontWidth: 'bold', fontSize: '16px', lineHeight: '24px', marginTop: '10px' }}>
                  Important message: Due to scheduled maintenance on Sunday 23th
                  February, 1:30 AM to 4:30 AM (GMT), this platform will be inaccessible
                  during the maintenance window.
                </span>
                <img src='/images/close-white.svg' alt='Close' className='close-banner' style={{ marginLeft: 10 }} onClick={handleCloseBanner} />
              </div>

            </div>
          </div>
        ) : null
      } */}

      {/* emailVerified */}

      {/* ########## Confirm Delete modal ############### */}
      <Modal
        show={localStorage.getItem('emailVerified') === 'false' ? true : false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // onHide={this.handleCloseModal}
        dialogClassName={"confirm-modal"}
      >
        <div className="p-4" >
          <div className='sticky-close'>
            <img src='/images/close.svg' alt='' onClick={goToLogin} />
          </div>
          <br />
          <div class="row" style={{ color: '#000000' }}>

            <div class="col-12">
              <h1 class="maintxt" style={{ color: '#000000' }}> {t('Please verify your email')}.</h1><br />
            </div>

            <div class="col-12">
              <span style={{ textAlign: 'center', fontSize: 14, fontWeight: 300, color: '#000000', }}>
                {t('Youre almost there! We sent an email to')}
              </span>
              <h6 class="subheading f-14" style={{ paddingTop: '1%' }}>{localStorage.getItem('email')}</h6>
            </div>

            <div class="col-12" >
              <span style={{ textAlign: 'center', fontSize: 14, fontWeight: 300, color: '#000000', paddingTop: '1%' }}>
                {t('just click on the link in that email to complete your signup. You may need to')} <strong>{t('check your spam folder if you dont see it')}.</strong>
                <br /><br />
                {t('Do you still need help finding the email? No problem')}.<br />
              </span>
            </div>
            <div class="col-12">
              <div className="save-btn text-center">
                <button onClick={resendEmail} style={{ paddingTop: '1%', width: 230 }}
                  type="button"> {t('Resend Verification Email')}
                </button>
                {/* onClick={() => dispatch(verifyEmail(localStorage.getItem('userId')))} */}
              </div>
            </div>
          </div>
        </div>
      </Modal >
    </div >
  );
}

export default App;
